<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" temporary fixed :width="300">
      <v-list-item height="125px">
        <v-list-item-avatar>
          <v-avatar size="40" color="primary">
            <span class="white--text text-h6 ml-1 prevent-select">{{
              loggedInName | truncate(2)
            }}</span>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <p class="subtitle-1 font-weight-medium my-3 mx-3">
              {{ loggedInName }}
            </p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list rounded>
        <v-subheader class="prevent-select">Docenten overzicht</v-subheader>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item
            color="primary"
            v-for="item in items"
            :key="item.title"
            link
            @click="navigateTo(item.routeName, item.external)"
            class="my-1"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-title>{{ item.subtitle }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="item.external">
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <div class="pa-2">
          <v-btn block color="primary" @click="logout()"
            ><v-icon class="pr-1">mdi-logout</v-icon>Uitloggen</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="primary"
      dark
      :height="$vuetify.breakpoint.mdAndUp ? '125px' : '100px'"
    >
      <v-btn color="white" icon class="mx-2" @click="drawer = true"
        ><v-icon :size="40"> mdi-menu </v-icon></v-btn
      >
      <v-spacer></v-spacer>
      <v-img
        :src="require('@/assets/images/logo/logo-wit.webp')"
        class="my-3 m-4 p-6 mr-0 pr-0 logo h-full"
        :max-width="$vuetify.breakpoint.mdAndUp ? '200px' : '125px'"
        contain
        style="cursor: pointer"
      />
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <v-scale-transition>
      <v-btn
        v-if="!helpDialog"
        fab
        dark
        large
        color="primary"
        fixed
        right
        bottom
        @click="helpDialog = !helpDialog"
      >
        <v-icon>mdi-help</v-icon>
      </v-btn>
    </v-scale-transition>
    <v-dialog
      id="bottom-right-dialog"
      content-class="bottom-right-dialog"
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="helpDialog"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="primary" dark>
            Vragen of feedback?
            <v-spacer></v-spacer>
            <v-btn text @click="dialog.value = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-2">
            <p>
              Heb je vragen, feedback of is iets onduidelijk? Dan kun je via
              onderstaand formulier dit doorgeven. Verder kun je altijd even een
              mailtje doen naar
              <a href="mailto:planning@tweb.nl">planning@tweb.nl</a> of een
              belletje naar
              <a href="tel:0528 280 888">0528 280 888</a> (keuzemenu optie 1)
            </p>
            <ValidationObserver ref="form">
              <form>
                <v-row class="pt-2">
                  <v-col>
                    <ValidationProvider
                      rules="required"
                      name="Naam"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        v-model="name"
                        label="Naam"
                        persistent-hint
                        :error="errors.length >= 1"
                        :error-messages="errors[0]"
                      ></v-text-field>
                    </ValidationProvider>

                    <ValidationProvider
                      rules="required"
                      name="optie"
                      v-slot="{ errors }"
                    >
                      <v-select
                        outlined
                        :items="questionOptions"
                        v-model="selectionOption"
                        label="Keuze opties"
                        persistent-hint
                        :error="errors.length >= 1"
                        :error-messages="errors[0]"
                      ></v-select>
                    </ValidationProvider>
                    <ValidationProvider
                      rules="required"
                      name="tekstveld"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        outlined
                        v-model="question"
                        label="Vraag/ feedback of opmerking"
                        persistent-hint
                        :error="errors.length >= 1"
                        :error-messages="errors[0]"
                      ></v-textarea>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-btn
                  color="primary"
                  block
                  class="mr-4"
                  submit
                  @click="sendQuestionFeedbackPortal"
                  >Versturen</v-btn
                >
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>

<style>
.fixedBottom {
  position: fixed !important;
  bottom: 0 !important;
  width: 100%;
}

.v-dialog__content:has(> .bottom-right-dialog) {
  align-items: end !important;
  justify-content: right !important;
}

.bottom-right-dialog {
  margin: 15px !important;
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TeacherLayout",
  data: () => ({
    drawer: null,
    items: [
      {
        title: "Agenda",
        icon: "mdi-calendar-month",
        routeName: "TeacherPortalView",
        external: false,
      },
      {
        title: "Aanvragen",
        icon: "mdi-calendar-cursor",
        routeName: "TeacherPortalRequestsView",
        external: false,
      },
      {
        title: "Handleiding /",
        subtitle: "Agenda-koppeling",
        icon: "mdi-help-circle-outline",
        routeName: "TeacherPortalManualView",
        external: false,
      },
      {
        title: "Docentenportaal",
        icon: "mdi-human-male-board",
        routeName: "https://docenten.tweb.nl/",
        external: true,
      },
    ],
    selectedItem: 0,
    helpDialog: false,
    questionOptions: [
      "Ik heb een vraag",
      "Ik heb feedback",
      "Ik heb ergens hulp bij nodig",
      "Ik zit met iets anders",
    ],
    selectionOption: null,
    name: "",
    question: "",
  }),
  computed: {
    ...mapGetters({
      isDevelopment: "tools/getIsDevelopment",
      serverEnvironment: "tools/getServerEnvironment",
    }),
    loggedInName() {
      let currentUser = this.$auth.user();
      if (currentUser == null || this.isEmptyObject(currentUser)) return "";
      return currentUser.fullname.replace(/ /g, "") == ""
        ? currentUser.email
        : currentUser.fullname;
    },
  },
  mounted() {
    this.fetchCurrentTeacher();

    this.setCurrentNavigation();
  },
  methods: {
    logout: function () {
      this.$auth.logout();
      this.$router.push({ name: "TeacherLogout" });
    },
    navigateTo(name, external) {
      if (!external) this.$router.push({ name: name });
      else {
        window.open(name, "_blank", "noreferrer");
      }
    },
    setCurrentNavigation() {
      let currentRoutename = this.$router.currentRoute.name;
      let itemIndex = this.items.findIndex(
        (x) => x.routeName == currentRoutename
      );
      if (itemIndex < 0) this.selectedItem = 0;

      this.selectedItem = itemIndex;
    },
    callMethod: function (method) {
      if (method == "logout") this.logout();
      else if (method == "openSettings") this.openSettings();
    },
    fetchCurrentTeacher() {
      this.$store
        .dispatch("teachers/fetchTeacherInformation")
        .then((result) => {
          let currentUser = this.$auth.user();
          if (this.isEmptyObject(currentUser)) {
            this.$auth.user(result);
          }
        })
        .catch(function () {
          this.$auth.user(null);
        });
    },
    sendQuestionFeedbackPortal() {
      this.$store.dispatch("toggleLoader");
      let app = this;
      const payload = {
        name: this.name,
        question: this.question,
        option: this.selectionOption,
      };
      this.$store
        .dispatch("teachers/sendQuestionFeedbackPortal", payload)
        .then(() => {
          app.$store.dispatch("toggleLoader");
          app.helpDialog = false;
          app.$store.dispatch("addMessage", {
            message: "Je bericht is succesvol verzonden!",
            bottom: true,
            top: false,
            right: true,
            color: "green",
            transition: "fab-transition",
            timeout: 3000,
          });

          //Clear fields
          app.name = "";
          app.question = "";
          app.selectionOption = null;
          app.$refs.form.reset();
        })
        .catch(function () {
          app.$store.dispatch("toggleLoader");
          app.$store.dispatch("addMessage", {
            message: "Er ging iets fout",
            bottom: true,
            top: false,
            right: true,
            color: "red",
            transition: "fab-transition",
            timeout: 3000,
          });
        });
    },
    isEmptyObject(obj) {
      return (
        obj &&
        Object.keys(obj).length === 0 &&
        Object.getPrototypeOf(obj) === Object.prototype
      );
    },
  },
};
</script>

<style scoped>
.prevent-select {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
